import { useState } from "react";
import kesaiSrc from "../assets/ai.jpg";
import styles from "./index.module.scss";

export const MobileAlgo2024 = () => {
  const [showCode, setShowCode] = useState(false);
  return (
    <div className={styles.page}>
      <div className={styles["top-bg"]}></div>
      <div className={styles["top-title"]}></div>
      <div className={styles["top-shadow"]}></div>
      <div className={styles["logo"]}></div>

      <div className={styles["title-intro"]} id="anchor-intro"></div>
      <div className={styles["text-intro"]}></div>

      <div className={styles["title-setup"]} id="anchor-setup"></div>

      <div className={styles["quiz1"]}></div>
      <div className={styles["quiz2"]}></div>

      <div
        className={styles["btn-entry1"]}
        onClick={() => setShowCode(!showCode)}
      ></div>
      {showCode && (
        <div className={styles["kesai-scan"]}>
          <img src={kesaiSrc} alt="可赛小程序码" />
        </div>
      )}
      <div
        className={styles["btn-entry2"]}
        onClick={() => setShowCode(!showCode)}
      ></div>

      <div
        className={styles["title-participants"]}
        id="anchor-participants"
      ></div>
      <div className={styles["text-participants"]}></div>
      <div className={styles["title-participants-icon"]}></div>

      <div className={styles["title-guests"]} id="anchor-guests"></div>
      <div className={styles["title-guests-shadow"]}></div>
      <div className={styles["guests__wrapper"]}>
        <div className={styles['guests-1']}></div>
        <div className={styles['guests-2']}></div>
        <div className={styles['guests-3']}></div>
        <div className={styles['guests-4']}></div>
        <div className={styles['guests-5']}></div>
        <div className={styles['guests-6']}></div>
      </div>

      <div className={styles["title-schedule"]} id="anchor-schedule"></div>
      <div className={styles["contest-timeline"]}></div>

      <div className={styles["title-prizes"]} id="anchor-prizes"></div>
      <div className={styles["prizes1"]}></div>
      <div className={styles["prizes2"]}></div>
      <div className={styles["prizes3"]}></div>
      <div className={styles["prizes-desc"]}></div>

      <div className={styles["title-contact"]} id="anchor-contact"></div>
      <div className={styles["text-contact"]}></div>

      <div className={styles["footer"]}></div>
    </div>
  );
};
